<template>
  <div id="chart" style="width: 100%;"/>
</template>

<style>
.svg-container {
  /* display: inline-block;
  position: relative; */
  width: 100%;
  padding-top: 0%;
  vertical-align: top;
  /* height: 600px; */
  /* overflow: hidden; */
}
.svg-content-responsive {
  /* display: inline-block;
  position: absolute; */
  top: 10px;
  left: 0;
}

</style>

<script>
import * as d3 from "d3";
import { scaleDiscontinuous, discontinuityRange } from 'd3fc';

export default {
  name: "bar-chart",
  props: ['data', 'total', 'yearPaymentsStart'],
  data() {
    return {
      chart: null,
    };
  },
  mounted(){
    this.renderChart()
  },
  watch:{
    data(a){
      this.clearChart()
      this.renderChart()
    },
    total(a){
      this.clearChart()
      this.renderChart()
    },
    yearPaymentsStart(a){
      this.clearChart()
      this.renderChart()
    }
  },
  methods: {
    clearChart(){
      d3.selectAll("#chart > *").remove();
    },
    renderChart() {
      this.data.forEach((item, index)=>{
        if (index == 0) {
          item.initalPayment = this.total
        } else {
          item.initalPayment = 0
        }
      })

      const margin = 60;
      // const svg_width = document.getElementById('chart').offsetWidth;
      const svg_width = 1100;
      const svg_height = 450;
      const chart_width = svg_width - 2 * margin;
      const chart_height = svg_height - 2 * margin;

      const svg = d3
        .select('#chart')
        .append("div")
        // Container class to make it responsive.
        .classed("svg-container", true)
        // .attr("height", svg_height)
        .append("svg")
        // Responsive SVG needs these 2 attributes and no width and height attr.
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("viewBox", "0 0 1150 500")
        // Class to make it responsive.
        .classed("svg-content-responsive", true)
        // Fill with a rectangle for visualization.
        .append("svg")
        .attr("width", '100%')
        .attr("height", svg_height);

      this.chart = svg
        .append("g")
        .attr("transform", `translate(${1.7*margin}, ${margin})`);

      const yScale = d3
        .scaleLinear()
        .range([chart_height, 0])
        .domain([-this.total*1.05, Math.max(...this.data.map(d=>d.totalCost))*1.05]);

      function formatTickText(d) {
        if (d<0){
          return this.parentNode.nextSibling ? `\xa0-$${-d}` : `-$${-d}`;
        } else {
          return this.parentNode.nextSibling ? `\xa0$${d}` : `$${d}`;
        }
      }

      this.chart
        .append("g")
        .call(d3.axisLeft(yScale)
              .ticks(5)
              // .tickSize(formatTickLength)
              .tickFormat(formatTickText))
        .call(g => g.selectAll(".tick line")
              .attr("stroke-opacity", 0.3))
        .call(g => g.selectAll(".tick text")
              .attr("font-size", 17))
      var numYears = this.data.length;
      var breakPoints = [this.data[0].year + 1, this.yearPaymentsStart - 1]
      var startYear = this.data[0].year - 1


      var xScale = scaleDiscontinuous(d3.scaleLinear())
          .discontinuityProvider(discontinuityRange([breakPoints[0], breakPoints[1]]))
          .domain([startYear, this.data[numYears-1].year + 1])
          .range([0, chart_width]);

      function formatXAxisTick (d){
        if (d>=breakPoints[0] && d<=breakPoints[1]){
          return '...'
        } else if (d<=startYear || d>= startYear+numYears + 1) {
          return ``;
        } else {
          return `${d}`;
        }
      }

      function adjustTextLabels(d) {
      }

      this.chart
        .append("g")
        .attr("transform", `translate(0, ${yScale(0)})`)
        .call(d3.axisBottom()
          .scale(xScale)
          .tickValues(Array(2000 - 20 + 1).fill().map((_, idx) => 20 + idx))
          .tickFormat(formatXAxisTick)
          .tickSize(0)
        )
        .call(g => g.selectAll(".tick text")
          .attr("transform", `translate(0, ${-yScale(0)-10})`))
          .attr("font-size", `17px`)

      const barGroups = this.chart
        .selectAll('rect')
        .data(this.data)
        .enter()

      var colors = ['#71C1C3', '#922409']
      var barWidth = xScale(1) - xScale(0)

      barGroups
        .append('rect')
        .attr('class', 'bar')
        .attr('x', (g) => xScale(g.year) - barWidth/2)
        .attr('y', (g) => yScale(g.payment))
        .attr('height', (g) => yScale(0) - yScale(g.payment))
        .attr('width', xScale(1)-xScale(0)-3)
        .attr('fill', (g)=>'#71C1C3')

      barGroups
        .append('rect')
        .attr('class', 'bar')
        .attr('x', (g) => xScale(g.year) - barWidth/2)
        .attr('y', (g) => yScale(0))
        .attr('height', (g) => yScale(-g.initalPayment)-yScale(0))
        .attr('width', xScale(1)-xScale(0)-3)
        .attr('fill', (g)=>'#922409')

      var legend = this.chart.append('g')
        .attr('class', 'legend')
        .attr('transform', `translate(${chart_width/3}, ${chart_height+10})`);

      var labels = ['Annual Pension Payments', 'Upfront Liability']

      legend.selectAll('rect')
        .data(labels)
        .enter()
        .append('rect')
        .attr('x', function(d, i){
            return i * 200;
        })
        .attr('y', 0)
        .attr('width', 12)
        .attr('height', 12)
        .attr('fill', function(d, i){
            return colors[i];
        });

      legend.selectAll('text')
        .data(labels)
        .enter()
        .append('text')
        .text(function(d){
            return d;
        })
        .attr('x', function(d, i){
            return 18 + i * 200;
        })
        .attr('y', 3)
        .attr('text-anchor', 'start')
        .attr('alignment-baseline', 'hanging');
    }
  }
};
</script>
